import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, ShieldAlert, Zap, Building2, Lock } from 'lucide-react';
import Button from '../common/design-system/Button';
import styles from './VerificationRequired.module.scss';

const VerificationRequired = () => {
    const navigate = useNavigate();

    const benefits = [
        {
            icon: <ShieldCheck size={16} />,
            title: "Visibilidad Total",
            desc: "Solo los negocios verificados aparecen en el feed exclusivo de creadores."
        },
        {
            icon: <Zap size={16} />,
            title: "Acceso Prioritario",
            desc: "Conecta con creadores verificados de alto impacto inmediatamente."
        },
        {
            icon: <Building2 size={16} />,
            title: "Identidad de Marca",
            desc: "Construye autoridad y confianza dentro de la comunidad FOTH."
        },
        {
            icon: <Lock size={16} />,
            title: "Pagos Seguros",
            desc: "Infraestructura de pagos protegida para todas tus colaboraciones."
        }
    ];

    return (
        <div className={styles['verification-required-view']}>
            <motion.div 
                className={styles['lock-container']}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            >
                <div className={styles['icon-wrapper']}>
                    <ShieldAlert size={32} />
                </div>

                <h1>Verificación Requerida</h1>
                <p className={styles['lead-text']}>
                    Para mantener la excelencia y seguridad en FOTH, necesitamos verificar tu negocio antes de que puedas publicar colaboraciones.
                </p>

                <div className={styles['benefits-grid']}>
                    {benefits.map((benefit, i) => (
                        <div key={i} className={styles['benefit-item']}>
                            <div className={styles['b-icon-wrap']}>
                                {benefit.icon}
                            </div>
                            <div className={styles['b-content']}>
                                <h4>{benefit.title}</h4>
                                <p>{benefit.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={styles.actions}>
                    <Button 
                        variant="primary" 
                        className={styles['main-btn']}
                        size="lg" 
                        onClick={() => navigate('/business/pending-approval')}
                    >
                        Iniciar Proceso de Verificación
                    </Button>
                    <button className={styles['support-link']} onClick={(e) => e.preventDefault()}>
                        ¿Necesitas ayuda? Contacta con soporte
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default VerificationRequired;
